import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { faUser } from '@fortawesome/free-solid-svg-icons';

type AvatarSize = 'sm' | 'md' | 'lg';

const avatarSizeMap: Record<AvatarSize, string> = {
  sm: 'size-10 text-lg',
  md: 'size-16 text-2xl',
  lg: 'size-24 text-4xl'
};

@Component({
  selector: 'ui-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: ` {{ initials() }} `,
  host: {
    '[class]': 'hostStyle()'
  }
})
export class Avatar {
  // Variables
  readonly faUser = faUser;

  // Inputs
  readonly size = input<keyof typeof avatarSizeMap>('sm');
  readonly firstName = input<string | null>();
  readonly lastName = input<string | null>();

  // Computeds
  readonly hostStyle = computed(() => {
    const size = this.size() ? avatarSizeMap[this.size()] : avatarSizeMap['sm'];
    return `${size} rounded-full bg-primary flex items-center justify-center text-primary-foreground font-semibold leading-none`;
  });
  readonly initials = computed(() => {
    const firstInitial = this.firstName()?.charAt(0).toUpperCase() ?? '';
    const lastInitial = this.lastName()?.charAt(0).toUpperCase() ?? '';
    return `${firstInitial}${lastInitial}`;
  });
}
